import { BaseModel } from './base';

export enum OverviewBlockType {
  single = 0,
  singleFinishing = 1,
  multi = 2,
  multiFinishing = 3,
}

export const OverviewBlockTypeLabels: Record<OverviewBlockType, string> = {
  [OverviewBlockType.single]: 'api.models.overviewBlock.single',
  [OverviewBlockType.singleFinishing]: 'api.models.overviewBlock.singleFinishing',
  [OverviewBlockType.multi]: 'api.models.overviewBlock.multi',
  [OverviewBlockType.multiFinishing]: 'api.models.overviewBlock.multiFinishing',
};

export enum OverviewBlockEmployeeFunction {
  notSure = 0,
  primary = 1,
  resource = 2,
}

export const OverviewBlockEmployeeFunctionLabels: Record<OverviewBlockEmployeeFunction, string> = {
  [OverviewBlockEmployeeFunction.notSure]: 'api.models.overviewBlock.notSure',
  [OverviewBlockEmployeeFunction.primary]: 'api.models.overviewBlock.primary',
  [OverviewBlockEmployeeFunction.resource]: 'api.models.overviewBlock.resource',
};

export class OverviewBlock extends BaseModel {
  type!: OverviewBlockType;
  employeeFunction!: OverviewBlockEmployeeFunction;
  idReservation!: number;
  idEmployee!: number;
  startTime!: number;
  duration!: number;
  processing!: number;
  finishing!: number;
}
